<template>
  <b-card
    body-class="p-0"
    class="-mt-[12px]"
  >
    <div class="flex items-center justify-between flex-wrap flex-col sm:flex-row gap-[16px] p-[18px]">
      <div class="flex items-center w-full sm:w-auto gap-[8px]">
        <b-button
          variant="primary"
          size="sm"
          class="rounded-lg p-0"
          @click="$router.go(-1)"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </b-button>
        <h3 class="text-xl text-black font-semibold w-full sm:w-auto mb-0">
          Pengajuan Produk
        </h3>
      </div>

      <div
        v-if="onGoingSubmission"
        class="flex items-center justify-end gap-[8px] grow flex-wrap w-full sm:w-auto"
      >
        <b-button
          :variant="!isAllSelected ? 'outline-secondary' : 'outline-primary'"
          :disabled="!isAllSelected"
          @click="rejectSubmission"
        >
          Tolak Pengajuan
        </b-button>
        <b-button
          variant="primary"
          :disabled="!thereIsOneSelected || isOnMutateApproval"
          @click="approveSubmission"
        >
          <b-spinner
            v-if="isOnMutateApproval"
            variant="white"
            small
          />
          {{ isOnMutateApproval ? 'Menyimpan...' : 'Setujui Pengajuan' }}
        </b-button>
      </div>
    </div>

    <div class="px-[18px] mb-[18px]">
      <p class="text-black mb-[2px] text-[14px]">
        Tanggal Pengajuan:
      </p>
      <p
        class="text-black font-semibold mb-0"
        :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-full max-w-[120px]': isOnLoading }"
      >
        {{ submissionDate }}
      </p>
    </div>

    <PartnerProfile
      :submission-detail="submissionDetail"
      :is-on-loading="isOnLoading"
    />

    <div class="mt-[24px] mb-[8px]">
      <div class="flex items-center justify-between mb-[16px]">
        <h4 class="text-black text-[16px] font-semibold px-[18px] mb-0">
          Daftar Produk
        </h4>
        <b-button
          v-if="!onGoingSubmission && rejectedSubmission"
          variant="outline-primary"
          size="sm"
          class="mx-[18px]"
          @click="viewRejectionNote"
        >
          Lihat Catatan Penolakan
        </b-button>
      </div>
      <ProductsTable
        ref="productsTable"
        :products="productData"
        :is-on-going-submission="onGoingSubmission"
        :is-on-loading="isOnLoading"
        @selection-change="handleSelectionChange"
      />
    </div>
    <ModuleSuccessApproval ref="moduleSuccessApproval" />
    <ModalViewRejectionNote ref="modalViewRejectionNote" />
    <ModuleRejectionReason
      ref="moduleRejectionReason"
      @on-success="handleRejectionSuccess"
    />
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { toastError, toastSuccess } from '@/libs/toastification'
import PartnerProfile from './PartnerProfile.vue'
import ProductsTable from './ProductsTable.vue'
import ModuleSuccessApproval from './ModuleSuccessApproval.vue'
import ModalViewRejectionNote from './ModalViewRejectionNote.vue'
import ModuleRejectionReason from './ModuleRejectionReason.vue'

export default {
  name: 'StorageRequestDetail',
  components: {
    PartnerProfile,
    ProductsTable,
    ModuleSuccessApproval,
    ModalViewRejectionNote,
    ModuleRejectionReason,
  },
  data() {
    return {
      isOnLoading: false,
      submissionDetail: undefined,
      submissionDetailError: false,
      isAllSelected: false,
      thereIsOneSelected: false,
      selectedProducts: [],
      isOnMutateApproval: false,
    }
  },
  computed: {
    ...mapState('auth', ['userData']),
    productData() {
      return this.submissionDetail?.details || []
    },
    submissionDate() {
      if (!this.submissionDetail?.submission_date) {
        return ''
      }
      return DAY_MONTH_YEAR(this.submissionDetail.submission_date)
    },
    onGoingSubmission() {
      return this.submissionDetail?.status === 'Diajukan'
    },
    rejectedSubmission() {
      return this.submissionDetail?.status === 'Ditolak'
    },
  },
  created() {
    this.fetchSubmissionDetail()
  },
  methods: {
    handleSelectionChange(selected) {
      this.isAllSelected = selected.length === this.productData.length
      this.thereIsOneSelected = selected.length > 0
      this.selectedProducts = selected
    },
    fetchSubmissionDetail() {
      this.isOnLoading = true
      return this.$http_new.get(`/komship/api/v1/submissions/${this.$route.params.id}/mitra`)
        .then(response => {
          const { data } = response.data
          const mappedData = {
            ...data,
            details: data.details.map(detail => {
              const isBundlingVarian = Array.isArray(detail.variant_bundles) && detail.variant_bundles.length > 0
              return {
                ...detail,
                is_bundling_varian: isBundlingVarian,
                _showDetails: detail.bundle_component?.length > 0 || isBundlingVarian,
              }
            }),
          }
          this.submissionDetail = mappedData
        }).catch(error => {
          this.submissionDetailError = true
          this.submissionDetail = undefined
        }).finally(() => {
          this.isOnLoading = false
        })
    },
    approveSubmission() {
      this.isOnMutateApproval = true
      const details = this.selectedProducts.map(product => ({
        submission_detail_id: product.submission_detail_id,
        product_id: product.product_id,
        is_product_bonus: product.is_product_bonus,
        product_variant_ids: product.product_variants?.map(variant => variant.variant_id),
        packings: product.packing_detail?.map(packing => ({
          packing_id: packing.packing_id,
          layer: packing.layer,
        })),
        storage_type: product.storage_type,
      }))
      const payload = {
        details,
      }

      this.$http_new.post(`/komship/api/v1/submissions/${this.$route.params.id}/confirm`, payload)
        .then(response => {
          this.fetchSubmissionDetail()
          this.$refs.moduleSuccessApproval.show()
        }).catch(() => {
          toastError('Gagal mengirimkan pengajuan, silahkan coba lagi.')
        }).finally(() => {
          this.isOnMutateApproval = false
        })
    },
    viewRejectionNote() {
      this.$refs.modalViewRejectionNote.show({
        note: this.submissionDetail?.reason,
      })
    },
    rejectSubmission() {
      const payload = {
        details: this.selectedProducts.map(product => ({
          submission_detail_id: product.submission_detail_id,
          product_id: product.product_id,
          is_product_bonus: product.is_product_bonus,
          product_variant_ids: product.product_variants?.map(variant => variant.variant_id),
          packings: product.packing_detail?.map(packing => ({
            packing_id: packing.packing_id,
            layer: packing.layer,
          })),
        })),
      }
      this.$refs.moduleRejectionReason.show(payload)
    },
    handleRejectionSuccess() {
      this.fetchSubmissionDetail()
    },
  },
}
</script>
